<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">

        <PageHeader :title="title" :items="items" />
        <b-card>
          <!-- <span style="font-size: 18px; font-weight: bold">Area Office</span> -->
          <!--          <button v-if="districts.length > 0"  type="button" id="export-table" @click="onexport"  class="btn btn-success float-right" style="margin-bottom:5px">Download Excel</button>-->
          <div>
            <table class="table table-bordered table-responsive table-centered" id="titledExcel">
              <thead>
                <tr>
                  <th rowspan="2">Sl</th>
                  <th>Name of Entitled Person(Eps)</th>
                  <th>Eps Father/Husband Name</th>
                  <th>Eps NID/Birth Certificate/Passport No</th>
                  <th>Eps Cell Phone No</th>
                  <th>Eps Address (Mouza/village,Union,Upazila and Zila)</th>
                  <th>SES No</th>
                  <th>Acquired Land/Plot No</th>
                  <th style="padding : 0 !important;">
                    <table>
                      <tr>
                        <th colspan="6">Acquired land (In Acqrs) and others per (JVSR)</th>
                        <th colspan="2">Dc Office CCL Paid (Yes go to next, No go to problems)</th>
                        <th colspan="3">CCL Informattion</th>
                        <th colspan="4">JVC Done (Acrec)</th>
                        <th colspan="2">100% FIle Preparation (Land Acrs)</th>
                        <th colspan="2">File Ongoing Process (out of RB)</th>
                        <th colspan="6">DC Un Paid (Acres) & EP</th>
                        <th colspan="2">Problems</th>
                      </tr>

                      <tr class="inner-table-header">
                        <th>Land</th>
                        <th>Structure</th>
                        <th>Tree</th>
                        <th>Seeds</th>
                        <th>Others</th>
                        <th>Total Taka (Net payment)</th>

                        <!-- Dc Office -->
                        <th>Yes</th>
                        <th>No</th>

                        <!-- CCL Informattion -->
                        <th>CCL Number</th>
                        <th>Payment Date</th>
                        <th>Taka</th>

                        <!-- JVC Done  -->
                        <th>EP ID Number</th>
                        <th>JVC Date</th>
                        <th>Land</th>
                        <th>%</th>

                        <!-- 100% file -->
                        <th>Land</th>
                        <th>%</th>

                        <!-- File Ongoing Process -->
                        <th>Land</th>
                        <th>%</th>

                        <!-- DC Un Paid -->
                        <th>Land</th>
                        <th>%</th>
                        <th>Structure</th>
                        <th>Trees</th>
                        <th>Seeds</th>
                        <th>Others</th>

                        <!-- problems -->
                        <th>DC Office</th>
                        <th>RB</th>
                      </tr>
                    </table>
                  </th>
                  <th rowspan="2">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(jvr, index) in jvr_reports" :key="jvr.id">
                  <td>{{index + 1}}</td>
                  <td>{{jvr.name}}</td>
                  <td>{{jvr.father_name}}</td>
                  <td></td>
                  <td></td>
                  <td>{{jvr.mouza.mouza_desc}}</td>
                  <td></td>
                  <td>{{jvr.plot.plot_no}}</td>
                  <td style="padding: 0 !important;">
                    <table class="inner-table table-centered">
                      <tr>
                        <td>{{jvr.lands}}</td>
                        <td>{{jvr.structures}}</td>
                        <td>{{jvr.trees}}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{{jvr.ccl_info.ccl_no}}</td>
                        <td></td>
                        <td>{{jvr.ccl_info.ccl_amount}}</td>
                      </tr>
                    </table>
                  </td>
                  <td>{{jvr.remarks}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'

export default {
  page: {
    title: "JVRS Report",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'JVRS Report',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'JVRS',
          active: true,
        },
      ],
      jvr_reports: [],
    }
  },

  mounted() {
    this.getCodes()
  },
  methods: {
    getCodes() {
      http.get("api/jvr/reports").then(response => {
        this.jvr_reports = response.data
        console.log(this.jvr_reports)
      });
    },
  },
}
</script>

<style>
.inner-table-header th,
.inner-table tr>td {
  min-width: 80px;
  max-width: 80px;
  height: 50px;
}
</style>
